import { createContext, useContext, ReactNode } from 'react';
import { ThemeProvider as Styled } from 'styled-components';
import { darkTheme } from '../styles/theme';

type Mode = 'dark';
interface Ctx {
  mode: Mode;
  toggle: () => void;
}

const ThemeCtx = createContext<Ctx>({ mode: 'dark', toggle: () => {} });
export const useThemeMode = () => useContext(ThemeCtx);

export default function ThemeModeProvider({ children }: { children: ReactNode }) {
  // Theme switching is suspended for now; app stays on dark mode.
  const toggle = () => {};

  return (
    <ThemeCtx.Provider value={{ mode: 'dark', toggle }}>
      <Styled theme={darkTheme}>{children}</Styled>
    </ThemeCtx.Provider>
  );
}
